import lineChart from "./lineChart";
const Charts={
     lineChart
}
export default Charts
//we